
import { ReactComponent as Logo } from "./svg/retbot.svg";

import authBg from "./jpg/auth-bg.jpg";
import banner from "./jpg/banner.jpg";
import homeBanner from "./jpg/home-banner.jpg";
import noAvatar from "./jpg/no-avatar.jpg";
import academyLogo from "./png/academy-logo.png";
import IconPng from "./png/retbot.png";

import avatar01 from "./png/avatar_01.png";
import avatar02 from "./png/avatar_02.png";
import avatar03 from "./png/avatar_03.png";
import avatar04 from "./png/avatar_04.png";
import avatar05 from "./png/avatar_05.png";
import avatar06 from "./png/avatar_06.png";


const Icon = {
    Logo,
}

const image = {
    authBg,
    banner,
    homeBanner,
    noAvatar,
    academyLogo,
    IconPng,
    avatar01,
    avatar02,
    avatar03,
    avatar04,
    avatar05,
    avatar06,
}

export {
    Icon,
    image,
};